module.exports = __webpack_public_path__ + "static/logo_autofun_slogan.1157e2a9.svg";